import { getProducts } from '@theme/shopify-helpers';

/**
 * Updates the recently viewed products in localStorage.
 */
export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed products in session storage */
  static #STORAGE_KEY = 'viewedProducts';
  static #PRODUCT_STORAGE_KEY = 'recentlyViewedProducts';
  /** @static @constant {number} The maximum number of products to store */
  static #MAX_PRODUCTS = 10;

  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productId - The ID of the product to add.
   */
  static async addProduct(productId) {
    let viewedProducts = this.getProducts();

    viewedProducts = viewedProducts.filter((/** @type {string} */ id) => id !== productId);
    viewedProducts.unshift(productId);
    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);

    localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));

    if (viewedProducts.length === 0) return;

    const recentlyViewedProducts = await getProducts(viewedProducts, 'id');
    const sortedReturnedProducts = this.sortArrayByOrder(
      recentlyViewedProducts,
      viewedProducts
    );

    const recentlyViewedObject = sortedReturnedProducts.map((product) => {
      return {
        id: product.node.id,
        title: product.node.title,
        handle: product.node.handle,
        vendor: product.node.vendor,
        image: product.node.images.nodes[0],
        priceRange: product.node.priceRange,
        compareAtPriceRange: product.node.compareAtPriceRange,
      };
    });

    localStorage.setItem(
      this.#PRODUCT_STORAGE_KEY,
      JSON.stringify(recentlyViewedObject)
    );
  }

  static clearProducts() {
    localStorage.removeItem(this.#STORAGE_KEY);
    localStorage.removeItem(this.#PRODUCT_STORAGE_KEY);
  }

  /**
   * Retrieves the list of recently viewed products from session storage.
   * @returns {string[]} The list of viewed products.
   */
  static getProducts() {
    return JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
  }

  static getDetailedProduct(){
    return JSON.parse(localStorage.getItem(this.#PRODUCT_STORAGE_KEY) || '[]');
  }

  static sortArrayByOrder(returnedProducts, updatedRecentlyViewed) {
    const orderMap = new Map()
  
    // Create a map with the order of each id
    updatedRecentlyViewed.forEach((id, index) => {
      orderMap.set(id, index)
    })
  
    // Sort the randomly returned Products based on the order map
    return returnedProducts.sort((a, b) => {
      return (
        orderMap.get(a.node.id.split('/').pop()) -
        orderMap.get(b.node.id.split('/').pop())
      )
    })
  }
}
